import React from 'react';
import { openLineColor } from '../../../constants/colors';
import AdmNivoChart from './AdmNivoChart';
import { findIntervalForDate, calculateOpenDefects, createLineConfig } from '../adm_shared/admChartUtils';

export default function AdmBacklogChart(props) {
  const { increment, arrival, closure, d0_date, d2_date } = props;

  // Early return if no arrival or closure data
  if (!arrival || !closure) {
    return null;
  }

  // Find D0 and D2 intervals from the arrival data
  const d0_interval = arrival && arrival.actual_processed
    ? findIntervalForDate(arrival.actual_processed, d0_date)
    : null;
  const d2_interval = arrival && arrival.actual_processed
    ? findIntervalForDate(arrival.actual_processed, d2_date)
    : null;

  const lines = [];

  // Calculate and add Open (Actual) - arrival minus closure
  if (arrival.actual_processed && arrival.actual_processed.length > 0 &&
      closure.actual_processed && closure.actual_processed.length > 0) {
    const openActual = calculateOpenDefects(arrival.actual_processed, closure.actual_processed);
    if (openActual.length > 0) {
      lines.push(createLineConfig('Open (Actual)', openActual, openLineColor, 'solid', true));
    }
  }

  // Calculate and add Open (Predicted) - arrival minus closure
  if (arrival.predicted && arrival.predicted.length > 0 &&
      closure.predicted && closure.predicted.length > 0) {
    const openPredicted = calculateOpenDefects(arrival.predicted, closure.predicted);
    if (openPredicted.length > 0) {
      lines.push(createLineConfig('Open (Predicted)', openPredicted, openLineColor, 'dashed', true));
    }
  }

  return (
    <AdmNivoChart
      title='Open Defect Prediction'
      lines={lines}
      chartHeight='24vw'
      allowHidingLines={true}
      allowHoverTooltip={true}
      xAxisLabel={`Interval (${increment} days)`}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
    />
  );
}
